'use client';

import { Box, IconButton, Typography } from '@mui/material';
import { Center } from '@ocodelib/mui';
import { sxAbsolute } from '@repo-foundation/util/sx-util';
import {
  AiTrainGuideDialog,
  type AiTrainGuideDialogProps,
} from '@repo-ui/dialogs/AiTrainGuideDialog';
import CodingListLayout from '@repo-ui/layout/CodingListLayout';
import MainLayout from '@repo-ui/layout/MainLayout';
import dynamic from 'next/dynamic';
import NextImage from 'next/image';
import { useState } from 'react';

type DialogParams = {
  id: 'AItrainGuideDialog';
  props: AiTrainGuideDialogProps;
};

// 데이터과학 목록
const BlockCodingList = dynamic(() =>
  import('@/features/coding/BlockCodingList').then((m) => m.BlockCodingList),
);

export default function Page() {
  return (
    <MainLayout>
      <CodingListLayout tab="block" title={<Title />}>
        <BlockCodingList />
      </CodingListLayout>
    </MainLayout>
  );
}

function Title() {
  const [dialogParams, setDialogParams] = useState<DialogParams | undefined>(undefined);
  const openAItrainGudieDialog = () => {
    setDialogParams({
      id: 'AItrainGuideDialog',
      props: {
        open: true,
        onClose: () => {
          setDialogParams(undefined);
        },
        kind: 'DATASCIENCE',
      },
    });
  };

  return (
    <Center>
      <Box sx={{ position: 'relative' }}>
        <Typography variant="h5" mr={1} sx={{ fontSize: '1.5rem' }}>
          블록코딩이란
        </Typography>

        <IconButton
          onClick={openAItrainGudieDialog}
          size="small"
          sx={{
            ...sxAbsolute({ top: 0, right: -30 }),
            ':hover': {
              backgroundColor: '#fff8e1',
            },
          }}
        >
          <NextImage src="/_static/images/icon_bulb.svg" width={22} height={22} alt="" />
        </IconButton>
      </Box>
      {dialogParams?.id === 'AItrainGuideDialog' && <AiTrainGuideDialog {...dialogParams.props} />}
    </Center>
  );
}
